import Footer from 'components/pageLayout/Footer';

export default function Layout(props) {
  const { children } = props;
  return (
    <>
      {children}
      <Footer />
    </>
  );
}
